import * as _ from 'lodash';

export function renderLink(text: string): string {
    if (!text?.length || typeof text !== 'string') {
        return '';
    }
    var matches: any = text.match(/(\[?#\d+[0-9a-zA-Z,.]*\]?)/g);

    if (!_.isEmpty(matches)) {
        matches = _.uniq(matches.sort((a:string, b:string):any => {
            return a.length < b.length;
        }));

        _.each(matches, (item) => {
            var tid = (item.match(/#\d+/)).toString().replace('#', '');

            var strDirective = '<tracker-item-link tid="' + tid + '" description="\'' + escape(item) + '\'" details="\'loading...\'" popover-type="\'tiedit\'"></tracker-item-link>';
            text = text.split(item).join(strDirective);
        });
    }
    return text;
}
